<template>
    <div>
        <div class="db_grid pt-0" id="infinite-list">
            <template v-for="(updatedsItem, ind) in updatesList ">
                <div  class="grid_element" :class="[templateClass+''+(ind+2)]" :key="ind">
                    <div @click="item=updatedsItem;goToDetaillPage()" class="grid_box " :class="{[checkProperty(updatedsItem['data'] ,'config' ,'class')]:checkProperty(updatedsItem['data'] ,'config' ,'class')  }"  v-bind:style="{ background: getGredieantColor(updatedsItem) ,border:getBorderColor() }" >
                    <span  class="link_arrow"></span>
                    <div>
                        <div class="title" >
                            <!-- <h3>{{checkProperty( updatedsItem ,"title" )}}</h3>  -->
                            <em>{{updatedsItem.createdOn | timeago}}</em>
                        </div>
                        
                        <div class="discription">
                            <div>
                                <p  class="pointer">{{checkProperty( updatedsItem ,"description" )}}</p>
                                <template v-if="false && ( checkProperty(updatedsItem ,'type') =='activity' || checkProperty(updatedsItem ,'type') =='todo' || checkProperty(widgetData ,'code')=='UPDATES')&& checkProperty( updatedsItem ,'createdByName' )">
                                    <p >
                                        <small>
                                        {{ checkProperty(updatedsItem ,'type') =='activity'?'Updated By':'Created By' }} <strong>{{ updatedsItem['createdByName'] }}</strong><template v-if="checkProperty( updatedsItem ,'createdByRoleName' )"> ({{checkProperty( updatedsItem ,'createdByRoleName' )}})</template>
                                        </small>
                                    </p>
                                </template> 
                            </div>
                            <div class="documents" v-if="checkProperty( updatedsItem , 'data','documents')">
                                

                                <template v-for="(fItem, findex) in checkProperty( updatedsItem , 'data','documents')">
                                    
                                    
                                    
                                    
                                    <span :key="findex" v-tooltip.top-center="fItem.name"   v-on:click.stop.prevent="downloads3file(fItem)"  class="note pointer">
                                    <docType  :item="fItem" />
                                    
                                    
                                    </span>
                                    
                                <!-- </template> -->
                                </template>
                                
                    
                                
                            </div>
                        </div>                     
                        </div> 
                            

                            <div class="avatar" v-if="checkProperty( updatedsItem ,'createdByName' )" >
                                <figure ><img  @error="setDefaultPhoto($event)" :src="checkProperty( updatedsItem,'createdByProfilePicture')"></figure>
                                <div class="avatar_info">
                            

                                    <figcaption>{{checkProperty( updatedsItem ,"createdByName" )}}<p v-if="checkProperty( updatedsItem ,'createdByRoleName')"> {{checkProperty( updatedsItem ,"createdByRoleName" )}}</p>
                                    </figcaption>
                                </div>
                            </div>

                                    
                    </div>
                </div>
            </template>
        </div>
    </div>
    
</template>
<script>
import docType from "@/views/common/docType.vue";
import Vue from 'vue'
import _ from "lodash";
import VTooltip from 'v-tooltip'
import JQuery from "jquery";
Vue.use(VTooltip)
var _isotope;
export default {
    components: {
        docType,
    },
    props: {
        updatesList:{
            type:Array,
            default:[]
        },
        // updatedsItem:null,
        templateClass:{
            type:String,
            default:'box'
        },
        inde:null  
    },
    methods:{
        goToDetaillPage(){
            let category = this.checkProperty( this.item ,"data" , "category");
            if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TASK_DETAILS"){
  
                 let taskId = this.checkProperty(this.item ,"data", "taskId");
                 
                  let path =  {'path':"/tasks-list" ,"query":{}};
                 if(taskId) {
                   path["query"]['id'] =taskId
                   this.$router.push(path);
  
                 }
                  
  
  
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "CAP_DETAILS"){
              let caseId = this.checkProperty(this.item ,'data' ,'petitionId');
              if(caseId) {
                this.$router.push({ path: `/cap-registration-details/${caseId}` ,query: {'filter':''} })
              }
              
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TENANT_DETAILS"){
  
                 let tenantId = this.checkProperty(this.item ,"data", "tenantId");
                 if(tenantId) this.$router.push("/customer-details/"+tenantId);
  
  
            }else  if((this.checkProperty(this.item ,'data' ,'navigationKey')=='LCA_DETAILS') ){
              
                let lcaId = this.checkProperty( this.item ,'data',"lcaId" );
                if(lcaId){
                    this.$router.push("/lca-inventory-details/"+lcaId);
                    //this.$store.dispatch("setPetitionTab" , 'set_LCA');
                    //this.findDetailsPage(petitionId);
                }else if(this.checkProperty( this.item ,'data',"petitionId" )){
                  let petitionId =  this.checkProperty( this.item ,'data',"petitionId" );
                  this.$store.dispatch("setPetitionTab" , 'set_LCA');
                  this.findDetailsPage(petitionId);

                }
                //petitionId
                   
  
            }else if(this.petitionToDoList.indexOf(category)>-1  ||  this.checkProperty(this.item ,'data' ,'navigationKey') =='PETITION_DETAILS' || this.checkProperty(this.item ,'data' ,'navigationKey') =='PERM_DETAILS'   ){
              
              this.navigateToDetails(this.item ,'CASE_DETAILS' ,'');
                   
  
            }else if( this.tenantTodoList.indexOf(category)>-1 || ['TENANT_STATUS_UPDATE'].indexOf(category)>-1){
  
                 let tenantId = this.checkProperty(this.item ,"data", "tenantId");
                 if(tenantId)
                    this.$router.push("/customer-details/"+tenantId);
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='USER_DETAILS'){
  
                this.$router.push("/users");
            }
            else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='COMPANY_DETAILS'){
             
                let companyId = this.checkProperty(this.item ,"data", "companyId")
                if(companyId)
                   this.$router.push("/petitioner-details/"+companyId);
            }else if( ['TICKET_DETAILS'].indexOf(this.checkProperty(this.item ,'data' ,'navigationKey'))>-1){
             
                let ticketId = this.checkProperty(this.item ,"data", "ticketId");
                if(ticketId)
                   this.$router.push("/ticket-details/"+ticketId);
            }
        },
        getGredieantColor(wallItem){
      let angle =118
        let color1 = '#EFF7FF'
        let color2 = '#DEEAF6'
      let returnValue =`linear-gradient(${angle}deg, ${color1} 0%, ${color2}  100%)`;
      if(this.checkProperty(wallItem ,"data" ,"config")){
        let config = wallItem['data']['config'];
        if( this.checkProperty( config ,'bgColor' ,"length")>0 ){
          //  returnValue =config['bgColor'][0];
        // return 'linear-gradient(118deg, '+config['bgColor'][0]+' 0%,'+ config['bgColor'][1]+' 100%);'
         angle =118
         color1 = config['bgColor'][0];
         if(this.checkProperty( config ,'bgColor' ,"length")>1 ){
            color2 = config['bgColor'][1] 
         }
         returnValue = color1
        //  returnValue= `linear-gradient(${angle}deg, ${color1} 0%, ${color2}  100%)`;
        }
      }
      return  returnValue;
        },
        getBorderColor(){
            let returnValue =``;
            if(this.checkProperty(this.item ,"data" ,"config")){
            let config = this.item['data']['config'];
            if( this.checkProperty( config ,'bgColor' ,"length")>1 ){
                let color1 = config['bgColor'][0]
                let color2 = config['bgColor'][1]
                returnValue =`1px solid ${color2}`;
            }
            }
            return returnValue;
        },
        initIsotop(resetIsotop=false){
            setTimeout(() => {
             // Force grid to relayout
             //console.log('Force grid to relayout')
             if(resetIsotop && this.isotopGrid ){
                this.isotopGrid.isotope('destroy')
                //this.isotopGrid.isotope('layout');
                this.isotopGrid=  jQuery(".db_grid").isotope({
                    layoutMode: "packery",
                    itemSelector: ".grid_element",
                    masonry: {
                        horizontalOrder: true,
                    },
                });

             }else{
               this.isotopGrid=  jQuery(".db_grid").isotope({
              layoutMode: "packery",
              itemSelector: ".grid_element",
              masonry: {
                horizontalOrder: true,
              },
            });
            if (jQuery(".db_grid").height() <= 50) {
              jQuery(".db_grid").height("auto");
              var _h = jQuery(".db_grid").innerHeight();
              jQuery(".db_grid").height(_h);
            }
             }
            }, 100);          
        },
    },
    data: () => ({
        item:null,
        isotopGrid:null,
        petitionToDoList : ["CREATE_PETITION" ,'SUBMIT_BY_BENEFICIARY','LCA_REQUEST' ,'SUBMIT_TO_LAW_FIRM' ,'ASSIGN_SUPERVISOR' ,"ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY" ,"REQUEST_DOC_EXECUTIVE_TO_UPLOAD","UPLOAD_BY_DOC_EXECUTIVE" ,"CASE_APPROVED"],
        assignmentActivityes : ['ASSIGN_SUPERVISOR' ,"ASSIGN_CASE_APPROVER","ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY"],
        tenantTodoList : ['TENANT_CREATED' ],
    }),
    mounted(){
        this.initIsotop();
    },
    computed:{

    }
}

</script>